<template>
  <div class="timeout-confirm-wrapper">
    <AppHeader title="前序实验超时确认"/>

    <div class="confirm-content">
      <div class="icon-wrapper">
        <i class="mint-icon mint-icon-info"></i>
      </div>

      <div class="message-title">前序用户实验超时</div>

      <div class="message-text">
        {{ confirmInfo.message }}
      </div>

      <div class="user-contact-card">
        <div class="contact-row">
          <span class="label">用户:</span>
          <span class="value">{{ confirmInfo.previousUserName }}</span>
        </div>
        <div class="contact-row">
          <span class="label">电话:</span>
          <span class="value">{{ confirmInfo.previousUserMobile }}</span>
          <a :href="`tel:${confirmInfo.previousUserMobile}`" class="call-btn">
            <i class="mint-icon mint-icon-phone"></i> 拨打
          </a>
        </div>
      </div>

      <div class="tip-text">
        请联系前序用户确认后,点击下方按钮继续上机
      </div>
    </div>

    <div class="action-buttons">
      <button class="btn btn-cancel" @click="cancel">取消</button>
      <button class="btn btn-confirm" @click="confirmAndStart">已确认,结束前序实验</button>
    </div>

    <!-- 加载遮罩 -->
    <div class="loading-overlay" v-if="loading">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <p>{{ loadingText }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.timeout-confirm-wrapper {
  min-height: 100vh;
  background: linear-gradient(#31B8D3, #1682A7);
  padding-bottom: 80px;
}

.confirm-content {
  padding: 20px;
  margin: 20px;
  background: white;
  border-radius: 8px;
}

.icon-wrapper {
  text-align: center;
  margin-bottom: 20px;

  .mint-icon {
    font-size: 60px;
    color: #F86719;
  }
}

.message-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 15px;
}

.message-text {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: center;
  margin-bottom: 20px;
  padding: 0 10px;
}

.user-contact-card {
  background: #F5F7FA;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;
}

.contact-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 15px;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    font-weight: bold;
    color: #333;
    min-width: 50px;
  }

  .value {
    flex: 1;
    color: #666;
  }

  .call-btn {
    display: inline-flex;
    align-items: center;
    padding: 5px 12px;
    background: #409EFF;
    color: white;
    border-radius: 4px;
    text-decoration: none;
    font-size: 13px;
    margin-left: 10px;

    .mint-icon {
      font-size: 14px;
      margin-right: 4px;
    }
  }
}

.tip-text {
  font-size: 13px;
  color: #999;
  text-align: center;
  line-height: 1.5;
}

.action-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 20px;
  background: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 15px;
}

.btn {
  flex: 1;
  height: 45px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.btn-cancel {
  background: #F5F7FA;
  color: #666;
}

.btn-confirm {
  background: #409EFF;
  color: white;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;

  p {
    color: white;
    margin-top: 15px;
    font-size: 14px;
  }
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>

<script>
import AppHeader from "@/components/AppHeader";
import { Toast, MessageBox } from 'mint-ui';
import store from "@/plugins/store";

export default {
  components: {
    AppHeader
  },
  data() {
    return {
      confirmInfo: null,
      equipmentId: null,
      loading: false,
      loadingText: '处理中...'
    };
  },
  mounted() {
    // 从路由参数中获取确认信息
    const info = this.$route.query.confirmInfo;
    this.equipmentId = this.$route.query.equipmentId;

    console.log('timeout-confirm 页面 mounted');
    console.log('路由参数 confirmInfo:', info);
    console.log('路由参数 equipmentId:', this.equipmentId);

    if (info) {
      try {
        this.confirmInfo = JSON.parse(decodeURIComponent(info));
        console.log('解析后的 confirmInfo:', this.confirmInfo);
        console.log('前置用户姓名:', this.confirmInfo.previousUserName);
        console.log('前置用户手机:', this.confirmInfo.previousUserMobile);
        console.log('前置实验ID:', this.confirmInfo.previousExperimentId);
      } catch (e) {
        console.error('解析 confirmInfo 失败:', e);
        Toast('参数错误');
        this.$router.back();
      }
    } else {
      console.error('缺少 confirmInfo 参数');
      Toast('缺少必要参数');
      this.$router.back();
    }
  },
  methods: {
    /**
     * 取消操作,返回首页
     */
    cancel() {
      this.$router.push('/');
    },

    /**
     * 用户确认后,调用confirmEndPrevious接口只结束前序实验
     * 添加二次确认对话框，防止误操作
     */
    async confirmAndStart() {
      const that = this;

      if (!this.confirmInfo || !this.equipmentId) {
        Toast('参数错误');
        return;
      }

      // 二次确认对话框
      this.$messagebox.confirm(
        `您确定已联系前序用户 ${this.confirmInfo.previousUserName} 并获得确认，要结束其实验吗？`,
        '确认操作',
        {
          confirmButtonText: '确定结束',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        // 用户确认后执行
        this.executeConfirmEndPrevious();
      }).catch(() => {
        // 用户取消操作
        console.log('用户取消操作');
      });
    },

    /**
     * 执行结束前序实验的操作（不开始新实验）
     */
    async executeConfirmEndPrevious() {
      const that = this;

      this.loading = true;
      this.loadingText = '正在结束前序实验...';

      try {
        // 获取当前预约信息
        const bookingRes = await this.$http.post(`/api/booking/getCurrentBooking?equipmentId=${this.equipmentId}`);

        if (!bookingRes.success || !bookingRes.data) {
          Toast('获取预约信息失败');
          this.loading = false;
          return;
        }

        const booking = bookingRes.data;

        // 调用confirmEndPrevious接口 - 只结束前序实验
        const res = await this.$http.post('/api/experiment/confirmEndPrevious', null, {
          params: {
            previousExperimentId: this.confirmInfo.previousExperimentId,
            eqcode: booking.equipment.code,
            finalAccounts: true
          }
        });

        this.loading = false;

        if (res.success) {
          Toast({
            message: res.data.message || '前序实验已结束，请点击确认上机',
            duration: 2000
          });

          // 存储当前预约信息
          store.commit('setCurBooking', booking);

          // 返回到 confirm 页面，让用户重新点击"确认上机"或"蓝牙上机"
          setTimeout(() => {
            that.$router.replace({
              path: '/confirm',
              query: {
                equipmentId: that.equipmentId
              }
            });
          }, 500);
        } else {
          Toast(res.msg || '操作失败');
        }
      } catch (error) {
        this.loading = false;
        console.error(error);
        Toast('网络请求失败');
      }
    }
  }
};
</script>
